import React, { Component, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { GetCityList } from '../../request/apiRquest';

const Navbar = () => {

 // let publicUrl = process.env.PUBLIC_URL + '/'
 // let imgattr = 'logo'
  // let anchor = '#'

  const [cities, setCities] = useState([])


  const getCityList = () => {
    GetCityList().then((res) => {
      setCities(res);
    })
  }

  useEffect(() => {
    getCityList();
  }, [])


  return (
    <div>
      <div className="navbar-area">
        <nav className="navbar navbar-area navbar-expand-lg">
          <div className="container nav-container">
            <div className="responsive-mobile-menu">
              <button className="menu toggle-btn d-block d-lg-none" data-toggle="collapse" data-target="#realdeal_main_menu" aria-expanded="false" aria-label="Toggle navigation">
                <span className="icon-left" />
                <span className="icon-right" />
              </button>
            </div>
            <div className="logo readeal-top">
              <Link to="/"><img src={"/assets/img/ts-logo.png"} alt="logo" /></Link>
            </div>
            {/* <div className="nav-right-part nav-right-part-mobile">
              <Link className="btn btn-yellow" to="/add-property">ADD LISTING <span className="right"><i className="la la-plus" /></span></Link>
            </div> */}
            <div className="collapse navbar-collapse" id="realdeal_main_menu">
              <ul className="navbar-nav menu-open readeal-top">

                <li><Link to="/">Home</Link></li>

                <li className="menu-item-has-children">
                  <a href="#">Off Plan Properties</a>
                  <ul className="sub-menu">
                    <li><a href="/search-grid?Ready_Underconstruction=2">Off Plans - All</a></li>
                    <li><a href="/search-grid?Ready_Underconstruction=2&PropertyType=1&States=2">OffPlans - Villas Dubai</a></li>
                    {/* state_id = 2 & statename is Dubai */}
                    <li><a href="/search-grid?Ready_Underconstruction=2&PropertyType=2&States=2">OffPlans - Appartment Dubai</a></li>
                    <li><a href="/search-grid?Ready_Underconstruction=2&PropertyType=1">OffPlans-By-Developer</a></li>
                  </ul>
                </li>

                {/* <li><a href="/search-grid?Ready_Underconstruction=2">Off Plans</a></li> */}
                <li><a href="/search-grid">Property</a></li>

                {/* <li className="menu-item-has-children">
                    <a href="#">Property</a>
                    <ul className="sub-menu">
                      <li><Link to="/property">Property</Link></li>
                      
                      <li><Link to="/availavbe-property">Luxury Properties Dubai</Link></li>
                    
                      <li><Link to="/properties-by-city">Commercial Properties</Link></li>
                
                      <li><Link to="/recent-properties">Industrial Properties</Link></li>
                      <li><Link to="/property-details">Property Details</Link></li>
                    </ul>
                  </li> */}

                {/* <li className="menu-item-has-children">
                    <a href="#">Pages</a>
                    <ul className="sub-menu">
                      <li><Link to="/About">About</Link></li>
                      <li><Link to="/advisor">Advisor</Link></li>
                      <li><Link to="/search-list">Search List</Link></li>
                      <li><Link to="/search-grid">Search Grid</Link></li>
                      <li><Link to="/faq">FAQ</Link></li>
                      <li><Link to="/pricing">Pricing</Link></li>
                      <li><Link to="/user-list">User List</Link></li>
                      <li><Link to="/Registration">Registration</Link></li>
                      <li><Link to="/error">404</Link></li>
                    </ul>
                  </li> */}

                <li className="menu-item-has-children">
                  <a href="#">Areas</a>
                  <ul className="sub-menu">
                    <li><a href="/search-grid">All Areas</a></li>
                    {cities?.map((city) => (
                      <>
                        <li><a href={`/search-grid?Cities=${city?.id}`}>{city?.name}</a></li>
                      </>
                    ))}
                    {/* <li><Link to="/search-grid?Cities=5">Business Bay</Link></li>
                      <li><Link to="/search-grid?Cities=5">Dubai Marina</Link></li>
                      <li><Link to="/search-grid?Cities=5">Downtown Dubai</Link></li>
                      <li><Link to="/search-grid?Cities=5">Jumeirah Lake Towers</Link></li>
                      <li><Link to="/search-grid?Cities=5">Jumeirah Village Circle</Link></li>
                      <li><Link to="/search-grid?Cities=5">Palm Jumeirah</Link></li> */}

                  </ul>
                </li>
                {/* <li><Link to="/search-grid">Areas</Link></li> */}
                <li><Link to="/services">Services</Link></li>

                <li><Link to="/blog">Blog</Link></li>

                {/* <li className="menu-item-has-children">
                    <a href="#">Blog</a>
                    <ul className="sub-menu">
                      <li><Link to="/news">News</Link></li>
                      <li><Link to="/news-details">News Details</Link></li>
                    </ul>
                  </li> */}
                {/* <li><Link to="/contact">Contact Us</Link></li> */}
                <li className="menu-item-has-children">
                  {/* <a href="/About">About Us</a> */}
                  <li><Link to="/About">About Us</Link></li>
                  <ul className="sub-menu">
                    {/* <li><Link to="/About">About Us</Link></li> */}
                    <li><Link to="/faq">FAQ</Link></li>
                    <li><Link to="/contact">Contact Us</Link></li>
                  </ul>

                </li>
              </ul>
            </div>
            {/* <div className="nav-right-part nav-right-part-desktop readeal-top">
                      <Link className="btn btn-yellow" to="/add-property">ADD LISTING <span className="right"><i className="la la-plus" /></span></Link>
                    </div> */}
          </div>
        </nav>
      </div>
    </div>
  )

}


export default Navbar